import { Outlet, Route, Routes } from 'react-router'
import { Link } from 'react-router-dom'
import { Tab } from '../components/tab'

export function Root() {
	return (
		<>
			<Routes>
				<Route path="/" element={<Main />} />
				<Route path="/create" element={<Create />} />
				<Route path="/:id/*" element={<Detail />} />
			</Routes>
			<div className="grow">
				<Outlet />
			</div>
		</>
	)
}

function Main() {
	return (
		<div className="mb-6 flex gap-4 justify-between items-center">
			<h2 className="text-lg">Poptávky</h2>
		</div>
	)
}

function Create() {
	return (
		<div className="flex items-center gap-4 mb-5">
			<Link to="../">←</Link>
			<h2 className="text-lg">Nová nabídka</h2>
		</div>
	)
}

function Detail() {
	return (
		<>
			<div className="flex items-center gap-4 mb-5">
				<Link to="../">←</Link>
				<h2 className="text-lg">Detail poptávky</h2>
			</div>
			<div className="flex gap-4 p-4 justify-between items-center">
				<nav className="border-b border-gray-200">
					<ul className="flex -mb-px">
						<li>
							<Tab to="." end>
								Základní
							</Tab>
						</li>
						<li>
							<Tab to="logs">Historie</Tab>
						</li>
					</ul>
				</nav>
			</div>
		</>
	)
}
